import { FormShell, RBButton } from '@scmlatam/web-ui';
import type { useFormDeletePaycode } from '../hooks/useFormDeletePaycode';

interface DeletePaycodeDialogProps {
    formProps: ReturnType<typeof useFormDeletePaycode>;
}

const DeletePaycodeDialog = ({ formProps }: DeletePaycodeDialogProps) => {
    return (
        <FormShell
            open={formProps.openForm}
            title={formProps.title}
            size="m"
            onClose={formProps.closeForm}
            loading={formProps.loading}
            footer={
                <div id="schedule-delete-paycode-footer" className="flex flex-wrap items-center justify-end gap-3 p-3">
                    <RBButton id="schedule-delete-paycode-cancel" variant="secondary" size="m" disabled={formProps.loading} onClick={formProps.closeForm}>
                        {formProps.t('delete_paycode.buttons.cancel')}
                    </RBButton>
                    <RBButton id="schedule-delete-paycode-delete" size="m" loading={formProps.loading} onClick={formProps.submit}>
                        {formProps.t('delete_paycode.buttons.delete')}
                    </RBButton>
                </div>
            }
        >
            <div id="schedule-delete-paycode-form" className="flex min-h-100 items-center gap-3 p-3">
                <p className="text-2xl">{formProps.t('delete_paycode.fields.message')}</p>
            </div>
        </FormShell>
    );
};

export { DeletePaycodeDialog };
